import { render, staticRenderFns } from "./InitialData.vue?vue&type=template&id=2078a9d2&scoped=true"
import script from "./InitialData.vue?vue&type=script&lang=js"
export * from "./InitialData.vue?vue&type=script&lang=js"
import style0 from "./InitialData.vue?vue&type=style&index=0&id=2078a9d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2078a9d2",
  null
  
)

export default component.exports